// NOTE: The actual redirect URLs are set at runtime in the AuthContext.tsx
// These values are placeholders that will be overridden
export const authConfig = {
  region: 'ap-southeast-2',
  userPoolId: 'ap-southeast-2_cFlfqglXf',
  userPoolWebClientId: '3q37cbdqcp9k129ut9kepvic1v',
  identityPoolId: 'ap-southeast-2:6a01a12f-60fa-4664-9032-713b3b7363d2',
  oauth: {
    domain: 'auth.dashboard.scorecheck.au',
    scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    // These placeholder URLs will be overridden at runtime
    redirectSignIn: ['http://localhost:3000/'],
    redirectSignOut: ['http://localhost:3000/'],
    responseType: 'code'
  },
  apiEndpoint: 'https://api.dashboard.scorecheck.au'
};

export const publicPaths = [
  '/login'
];